//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import numericsimple from "@/components/numericSimple";
import logger from "@/utils/logger";

  export default {
    props: {
      article: {},
    },
    data() {
      return {
        row: {},
        
        Products: [],
        FilterProducts: [],
        
        showDialog: false,        
        busy: false,
        pagination: {
          page: 1,
          rowsPerPage: 0, // 0 means all rows
        },
        columns: [
        {
            name: "productNumber",
            align: "left",
            label: "Produkt Nr.",
            field: (row) => row.componentPartProduct.productNumber,
            
          },
          {
            name: "product",
            align: "left",
            label: "Produkt",
            field: (row) => row.componentPartProduct.productName,
            
          },
          {
            name: "unit",
            align: "left",
            label: "Enhet",
            field: (row) => row.componentPartProduct.unit,
            
          },
          {
            name: "quantity",
            align: "left",
            label: "Antall",
            field: "quantity",
          },          
          
          {
            name: "priceExVat",
            align: "right",
            label: "Salgspris (eks. mva.)",
            field: (row) => (row.componentPartProduct.priceExVat * row.quantity).toFixed(2),
          },
          {
            name: "weightedAverageCostPrice",
            align: "right",
            label: "Veiet innpris",
            field: (row) => (row.componentPartProduct.weightedAverageCostPrice * row.quantity).toFixed(2),
          },
        ],
      };
    },
    components: {
      numericsimple
    },
    created() {
        this.getProducts();  

      },

    methods: {

        ...mapActions("main", ["getArticles"]),

      onCreateClick() {
      
        this.clearForm();
        this.showDialog = true;
      },
  
      onRowClick(evt, row) {
        this.row = row;
        
        this.quantity = row.quantity;
        this.showDialog = true;
      },

      CalculateInPrice(){        
        var sum = 0;
        
        this.article.components.forEach(function (item) {
          var componentsSum = item.quantity * item.componentPartProduct.weightedAverageCostPrice;
            sum = sum + componentsSum
        });
        return sum.toFixed(2);
      },

      CalculateOutPrice(){        
        var sum = 0;
        
        this.article.components.forEach(function (item) {
          var componentsSum = item.quantity * item.componentPartProduct.priceExVat;
            sum = sum + componentsSum
        });
        return sum.toFixed(2);
      },

      async getProducts() {
        this.Products = await this.getArticles();     
        this.FilterProducts = this.Products; 
      },

      getFilter(val, update) {
      if (!this.Products) {
        update();
        return;
      }
        update(() => {
          this.Products = this.FilterProducts.filter(
            (w) =>
              w.productName.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              w.productNumber
                .toString()
                .toLowerCase()
                .indexOf(val.toLowerCase()) > -1
          );
        }
      );
    },
  
      async createOrUpdate() {
      
        if(!this.row.componentPartProduct || !this.row.quantity)
        {    
            logger.log("invalid createOrUpdate")
        }
        else
        {
            if(!this.row.id){ 
                this.row.id = Math.floor(Math.random() * -1000000 + 1); // hack to get a unique id.
                this.article.components.push(this.row);
            }
           

            this.clearForm();
        }
      },
  
      clearForm() {
        this.row = {};
        this.showDialog = false;
      },
  
      async deleteClick() {
        this.article.components = this.article.components.filter(
        (component) => component.id !== this.row.id
      );
        this.clearForm();
      },

     
    },
  };
  